export default "__VITE_ASSET__BA19iA2b__"